import { Route, Redirect } from "react-router-dom";
import React, { Suspense, lazy, Fragment } from "react";
import Loader from "react-loaders";

import { ToastContainer } from "react-toastify";

import ProtectedRoute from "../CC/ProtectedRoute";

//PAGES
const Login = lazy(() => import("../Intro/Login"));
const Recover = lazy(() => import("../Intro/Recover"));
const Articles = lazy(() => import("../Articles"));
const Activity = lazy(() => import("../Activity"));
const Analysis = lazy(() => import("../Analysis"));
const Agents = lazy(() => import("../Agents"));
const Commands = lazy(() => import("../Commands/index"));
const Complaints = lazy(() => import("../Complaints/index"));
const Dashboards = lazy(() => import("../DashboardsV2"));
const FurnitureDivison = lazy(() => import("../FurnitureDivision"));
const Invoices = lazy(() => import("../Invoices"));
const Leads = lazy(() => import("../Leads"));
const Logistics = lazy(() => import("../Logistics"));
const MDFSection = lazy(() => import("../MDFSection"));
const Outputs = lazy(() => import("../Outputs"));
const PALSection = lazy(() => import("../PALSection/index"));
const Partners = lazy(() => import("../Partners"));
const Production = lazy(() => import("../Production"));
const ProductionRoutes = lazy(() => import("../ProductionRoutes"));
const Organization = lazy(() => import("../Organization"));
const Offers = lazy(() => import("../Offers"));
const Targets = lazy(() => import("../Targets"));
const Wallet = lazy(() => import("../Wallet"));
const WarehouseSection = lazy(() => import("../WarehouseSection"));
const Users = lazy(() => import("../Users"));
const Catalogues = lazy(() => import("../Catalogues"));

const Fallback = (
  <div className="loader-container">
    <div className="loader-container-inner">
      <div className="text-center">
        <Loader type="ball-grid-beat" />
      </div>
      <h6 className="mt-3">
        Date in curs de afisare...
        <small>Va rugam asteptati</small>
      </h6>
    </div>
  </div>
);

const AppMain = () => {
  return (
    <Fragment>
      <Suspense fallback={Fallback}>
        <Route path="/login" component={Login} />
      </Suspense>

      <Suspense fallback={Fallback}>
        <Route path="/recover" component={Recover} />
      </Suspense>

      <Suspense fallback={Fallback}>
        {/* <Route path="/activity" component={Activity} /> */}
        <ProtectedRoute path="/agents" component={Agents} />
      </Suspense>

      <Suspense fallback={Fallback}>
        {/* <Route path="/activity" component={Activity} /> */}
        <ProtectedRoute path="/activity" component={Activity} />
      </Suspense>

      <Suspense fallback={Fallback}>
        {/* <Route path="/activity" component={Activity} /> */}
        <ProtectedRoute path="/articles" component={Articles} />
      </Suspense>

      <Suspense fallback={Fallback}>
        {/* <Route path="/activity" component={Activity} /> */}
        <ProtectedRoute path="/analysis" component={Analysis} />
      </Suspense>

      <Suspense fallback={Fallback}>
        <ProtectedRoute path="/catalogues" component={Catalogues} />
      </Suspense>

      <Suspense fallback={Fallback}>
        <ProtectedRoute path="/commands" component={Commands} />
      </Suspense>

      <Suspense fallback={Fallback}>
        <ProtectedRoute path="/complaints" component={Complaints} />
      </Suspense>

      <Suspense fallback={Fallback}>
        {/* <Route path="/dashboards" component={Dashboards} /> */}
        <ProtectedRoute path="/dashboards" component={Dashboards} />
      </Suspense>

      <Suspense fallback={Fallback}>
        {/* <Route path="/dashboards" component={Dashboards} /> */}
        <ProtectedRoute path="/furnitureDivision" component={FurnitureDivison} />
      </Suspense>

      <Suspense fallback={Fallback}>
        {/* <Route path="/dashboards" component={Dashboards} /> */}
        <ProtectedRoute path="/invoices" component={Invoices} />
      </Suspense>

      <Suspense fallback={Fallback}>
        <ProtectedRoute path="/leads" component={Leads} />
      </Suspense>

      <Suspense fallback={Fallback}>
        <ProtectedRoute path="/logistics" component={Logistics} />
      </Suspense>

      <Suspense fallback={Fallback}>
        <ProtectedRoute path="/MDFSection" component={MDFSection} />
      </Suspense>

      <Suspense fallback={Fallback}>
        <ProtectedRoute path="/outputs" component={Outputs} />
      </Suspense>

      <Suspense fallback={Fallback}>
        {/* <Route path="/personalPrices" component={Prices} /> */}
        <ProtectedRoute path="/PALSection" component={PALSection} />
      </Suspense>

      <Suspense fallback={Fallback}>
        {/* <Route path="/personalPrices" component={Prices} /> */}
        <ProtectedRoute path="/partners" component={Partners} />
      </Suspense>

      <Suspense fallback={Fallback}>
        {/* <Route path="/personalPrices" component={Prices} /> */}
        <ProtectedRoute path="/production" component={Production} />
      </Suspense>

      <Suspense fallback={Fallback}>
        {/* <Route path="/personalPrices" component={Prices} /> */}
        <ProtectedRoute path="/productionRoutes" component={ProductionRoutes} />
      </Suspense>

      <Suspense fallback={Fallback}>
        {/* <Route path="/organization" component={Organization} /> */}
        <ProtectedRoute path="/organization" component={Organization} />
      </Suspense>

      <Suspense fallback={Fallback}>
        {/* <Route path="/organization" component={Organization} /> */}
        <ProtectedRoute path="/offers" component={Offers} />
      </Suspense>

      <Suspense fallback={Fallback}>
        {/* <Route path="/organization" component={Organization} /> */}
        <ProtectedRoute path="/targets" component={Targets} />
      </Suspense>

      <Suspense fallback={Fallback}>
        {/* <Route path="/organization" component={Organization} /> */}
        <ProtectedRoute path="/wallet" component={Wallet} />
      </Suspense>

      <Suspense fallback={Fallback}>
        <ProtectedRoute path="/warehouse" component={WarehouseSection} />
      </Suspense>

      <Suspense fallback={Fallback}>
        <ProtectedRoute path="/users" component={Users} />
      </Suspense>

      <Route exact path="/" render={() => <Redirect to="/login" />} />
      <ToastContainer />
    </Fragment>
  );
};

export default AppMain;
